<template>
  <div>
    <el-drawer
      :visible.sync="addServiceDialog"
      size="50%"
      title="数据节点"
      :before-close="handleClose"
    >
      <div class="box">
        <el-form :model="form" label-width="auto" :rules="rules" ref="mapForm">
          <el-form-item label="从设备名称" prop="name">
            <el-input v-model="form.name" placeholder="设备名称"></el-input>
          </el-form-item>
          <el-form-item label="数据类型" prop="data_type" required>
            <el-select v-model="form.data_type" placeholder="请选择">
              <el-option
                v-for="item in dataType"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="从机地址" prop="slave_id" required>
            <el-input type="number" v-model="form.slave_id" placeholder="从机地址"></el-input>
          </el-form-item>
          <el-form-item label="寄存器地址" prop="address">
            <el-input
            type="number" 
              v-model="form.address"
              placeholder="寄存器地址"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="寄存器数量">
          <el-input
            v-model="form.reg_count"
            placeholder="寄存器数量"
          ></el-input>
        </el-form-item> -->
          <el-form-item label="功能码" prop="function_code" required>
            <el-select v-model="form.function_code" placeholder="请选择">
              <el-option
                v-for="item in functionCodeType"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="读写类型" required>
            <el-radio-group v-model="form.is_writable">
              <el-radio :label="false">只读</el-radio>
              <el-radio :label="true">读写</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="字节序">
            <el-select
              v-model="form.byte_order"
              placeholder="请选择"
            >
              <el-option
                v-for="item in byteOrderType"
                :key="item.id"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="缩放因子">
            <el-input
              v-model="form.scaling_factor"
              placeholder="值 = 设备原始值 * 缩放因子 + 偏移量 "
            ></el-input>
          </el-form-item>
          <el-form-item label="偏移量">
            <el-input
              v-model="form.n_offset"
              placeholder="值 = 设备原始值 * 缩放因子 + 偏移量 "
            ></el-input>
          </el-form-item>
          <el-form-item label="属性名">
            <el-input v-model="form.attribute" placeholder="属性名"></el-input>
          </el-form-item>
          <el-form-item label="单位">
            <el-input v-model="form.unit" placeholder="如：°C %等"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input v-model="form.n_sort" placeholder="序号"></el-input>
          </el-form-item>
          <el-form-item label="设备说明">
            <el-input type="textarea" v-model="form.descr" placeholder="设备说明"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addServiceDialog = false">取 消</el-button>
          <el-button
            v-if="form.id"
            type="primary"
            :loading="loading"
            @click="updateForm()"
            >修 改</el-button
          >
          <el-button
            v-else
            type="primary"
            :loading="loading"
            @click="submitForm()"
            >添 加</el-button
          >
        </span>
      </div>
    </el-drawer>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
import {
  dataType,
  functionCodeType,
  byteOrderType,
} from "@/views/deviceManage/components/dict";
export default {
  data() {
    return {
      dataType,
      functionCodeType,
      byteOrderType,
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      device:{},
      loading: false,
    };
  },

  mounted() {
    
  },
  methods: {
    open(info,d) {
      this.device = d
      if (info && info.id) {
        this.temp = Object.assign({}, info);
        this.form = info;
      } else {
        this.form = this.temp = Object.assign({ is_writable: false,reg_count: 1 }, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      this.form.device_id = this.device.id;
      let url = "/device/deviceNode/insert";
      this.loading = true;
      this.$axios
        .post(url, this.form)
        .then((res) => {
          this.loading = false;
          this.$message({ type: "warning", message: "添加成功!" });
          this.addServiceDialog = false;
          this.form = {};
          this.$emit("success");
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      if (Object.keys(data).length == 0) {
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        return;
      }
      data.id = this.form.id;
      let url = "/device/deviceNode/update";
      this.loading = true;
      this.$axios
        .post(url, data)
        .then((res) => {
          this.loading = false;
          this.$message({ type: "success", message: "修改成功!" });
          this.addServiceDialog = false;
          this.form = {};
          this.temp = {};
          this.$emit("success");
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>
  
  <style lang="less" scoped>
.box {
  width: 100%;
  padding: 0 30px;
}
</style>